import styled from 'styled-components';
import { mediaq } from '~/themes/style-utils-v2';
import { images, newColors } from '~/themes/variables';
export const PreNeedBanner = styled.div `
  background: url(${(props) => props.bannerImage ?? images.preNeedBanner}) lightgray 50% / cover no-repeat;
  width: 430px;
  height: 284px;
  ${mediaq.md `
    background: url(${(props) => props.mobileBannerImage ?? images.preNeedMobileBanner}) lightgray 50% / cover no-repeat;
    width: 486px;
    height: 180px;
    display: ${(props) => (props.stage !== 1 ? 'none' : 'block')};
  `}
`;
export const TwoColumnRow = styled.div `
  display: flex;
  flex-direction: row;
  align-items: stretch;
  ${mediaq.md `
    flex-direction: column;
  `}
  ${mediaq.sm `
    height: 100%;
  `}
`;
export const Column = styled.div `
  flex: 1;
  ${mediaq.sm `
    flex: 0;
  `}
  &:not(:first-child) {
    background: #F7F7F7;
    ${mediaq.md `
      background: ${newColors.snow};
    `}
  }
`;
export const DialogWrapper = styled.div `
  position: fixed;
  inset: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${mediaq.sm `
    overflow-y: auto;
    box-sizing: border-box;
    align-items: flex-end;
  `}
`;
export const DialogPanel = styled.div `
  width: 100%;
  max-width: 860px;
  background: ${newColors.snow};
  border-radius: 18px;
  ${mediaq.md `
    max-width: 486px;
  `}
  ${mediaq.sm `
    max-height: calc(100dvh - 16px);
    overflow-y: auto;
    border-radius: 18px 18px 0 0;
  `}
`;
export const DialogOverlay = styled.div `
  position: fixed;
  inset: 0;
  background: rgba(75, 69, 81, 0.50);
`;
export const CloseButton = styled.img `
  float: right;
  cursor: pointer;
  margin: 16px 16px 0 0;
  display: block;
  ${mediaq.md `
    margin: ${(props) => props.stage !== 3 ? '0' : '16px 16px 0 0'};
    display: ${(props) => (props.display && props.stage !== 3 ? props.display : 'block')};
  `}
`;
export const ColumnWrapper = styled.div `
  padding: 40px;
  ${mediaq.md `
    background: linear-gradient(184.6deg, #ededed -8.81%, #dddae0 60.04%, #e2ccc5 125.02%);
    background-blend-mode: multiply;
    color: ${newColors.gray800};
    display: ${(props) => (props.stage === 3 ? 'none' : 'block')};
  `}
`;
export const FooterWrapper = styled.div `
  display: block;
  ${mediaq.md `
    display: ${(props) => (props.display ? 'none' : 'block')};
  `}
  > img {
    padding-left: 40px;
    padding-bottom: 20px;
    max-height: fit-content;
  }
`;
export const BreakPointWrapper = styled.div `
  display: none;
  ${mediaq.md `
    display: block;
    padding: 0 12px;
    height: 60px;
    display: flex;
    justify-content: ${(props) => (props.stage === 2 ? 'center' : 'space-between')};
    align-items: center;
  `}
`;
export const DialogDescription = styled.p `
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #4b4551;
  margin: 16px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  ${mediaq.md `
    text-align: center;
    margin: 0;
    display: ${(props) => (props.display ? 'none' : 'block')};
  `}
`;
export const DialogForm = styled.div `
  display: inline-block;
  text-align: center;
  width: 100%;
  height: 100%;
  padding: 50px;
`;
// For preNeedStage === 2 ? 10px 50px 50px 50px: 50px;
export const DialogFormTitle = styled.div `
  font-family: 'Inria Serif';
  font-style: normal;
  font-weight: 700;
  font-size: ${(props) => (props.stage === 2 ? '18px' : '24px')};
  line-height: 34px;
  color: #4b4551;
  white-space: pre-line;
  margin: ${(props) => (props.stage === 3 ? '30px 75px 0px' : props.stage === 2 ? '80px 0px 0px' : '110px 0px 0px')};
  ${mediaq.md `
    margin: ${(props) => (props.stage === 3 ? '30px 75px 0px' : '0px')};
    font-size: ${(props) => (props.stage !== 1 ? '18px' : '24px')};
  `}
  ${mediaq.sm `
    margin: ${(props) => (props.stage === 3 ? '30px 40px 0px' : '0px')};
    font-size: 18px;
  `}
`;
export const DialogFormSubTitle = styled.div `
  text-align: center;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${newColors.gray500};
  white-space: pre-line;
  margin: ${(props) => (props.stage === 3 ? '20px 0px 30px 0' : '14px 0 0 0')};
  ${mediaq.md `
    white-space: normal;
    margin: ${(props) => (props.stage === 3 ? '20px 45px 30px' : '10px 0 0 0')};
    font-size: ${(props) => (props.stage !== 1 ? '14px' : '16px')};
    line-height: ${(props) => (props.stage !== 1 ? '20px' : '24px')};
  `}
  ${mediaq.sm `
    margin: ${(props) => (props.stage === 3 ? '20px' : '10px 0 0 0')};
    font-size: 14px;
    line-height: 20px;
  `}
  > a {
    font-weight: 600;
    color: ${newColors.purple500};
    text-decoration: underline;
  }
`;
export const OptionGroup = styled.div `
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: 70px 0 130px;
  ${mediaq.md `
    margin: 30px 0 40px;
  `}
`;
export const OptionContainer = styled.div `
  height: 95px;
  padding: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 4px;
  border-radius: 12px;
  border: ${({ selected }) => (selected ? '2px' : '1px')} solid ${({ selected }) => (selected ? newColors.purple500 : newColors.gray500)};
  background: ${newColors.snow};
  cursor: pointer;

  &:hover {
    border-color: ${newColors.purple500};
  }
`;
export const OptionBlock = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
  &:not(:first-child) {
    justify-content: flex-end;
  }
  &[type='checkbox'] {
    accent-color: ${newColors.purple500};
  }
`;
export const Card = styled.div `
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex: 1 0 0;
`;
export const CardIcon = styled.div `
  width: 40px;
  height: 40px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid ${({ selected }) => (selected ? newColors.purple500 : newColors.gray100)};
  background: ${({ selected }) => (selected ? newColors.purple500 : newColors.snow)};
`;
export const CardLabel = styled.div `
  color: ${newColors.gray900};
  font-size: var(--Font-size-text-sm, 14px);
  font-style: normal;
  font-weight: 500;
  line-height: var(--Line-height-text-sm, 20px);
  text-align: start;
  white-space: pre-line;
`;
export const Checkbox = styled.input `
  width: 20px;
  height: 20px;
  border-radius: 6px;
  cursor: pointer;
  border: 1px solid ${newColors.gray200};
  accent-color: ${newColors.purple500};
`;
export const GoBack = styled.div `
  float: left;
  font-style: normal;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  cursor: pointer;
  color: ${newColors.purple500};
  text-decoration: underline;
  ${mediaq.md `
    display: ${(props) => (props.display ? 'none' : 'block')};
  `}
`;
export const Form = styled.form `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 24px;
  padding-top: 20px;
`;
export const TermsAndConditions = styled.div `
  display: inline-block;
  font-size: 12px;
  font-weight: 400;
  color: ${newColors.gray500};
  margin: 0;
  white-space: pre-line;
  > a {
    font-weight: 600;
    color: ${newColors.purple500};
    text-decoration: underline;
  }
`;
export const SubmitButton = styled.button `
  background: ${newColors.purple500};
  color: white;
  font-size: 12px;
  font-weight: 575;
  border-radius: 9999px;
  padding: 10px;
  width: 320px;
  outline: none;
  border: none;
  margin-top: 12px;
  margin-bottom: 4px;
  ${mediaq.md `
    font-size: 16px;
    width: 304px;
    padding: 16px;
    margin-top: 24px;
    margin-bottom: 0px;
  `}
`;
